import { useFormik } from 'formik'
import { useEffect } from 'react'
import { Button } from '../../components/button'
import CustSwitch from '../../components/switch'
import { HeaderSubheader } from '../../components/typography/HeaderSubheader'
import {
  useGetSettlementConfigQuery,
  useUpdateSettlementConfigMutation,
} from '../../redux-toolkits/settings/settings.slice'

export const SettlementConfiguration = () => {
  const { data: settlementConnfig, isFetching: fetchingSettlementConfig } =
    useGetSettlementConfigQuery(undefined, {
      refetchOnMountOrArgChange: true,
    })

  const [updateSettlementConfig, { isLoading: updatingSettlement }] =
    useUpdateSettlementConfigMutation()

  const { handleSubmit, values, setFieldValue } = useFormik({
    initialValues: {
      vendor: false,
      referral: false,
      affiliate: false,
      ambassador: false,
    },
    onSubmit: async (values) => {
      await updateSettlementConfig(values)
    },
  })

  useEffect(() => {
    if (settlementConnfig?.data) {
      setFieldValue('affiliate', settlementConnfig.data.affiliate)
      setFieldValue('referral', settlementConnfig.data.referral)
      setFieldValue('vendor', settlementConnfig.data.vendor)
      setFieldValue('ambassador', settlementConnfig.data.ambassador)
    }
  }, [settlementConnfig?.data])

  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <HeaderSubheader
          title="Settlement"
          text="Enable/disable settlements"
          className="max-w-fit"
        />

        <Button
          label={'Save'}
          primary
          onClick={() => {
            handleSubmit()
          }}
          size="medium"
          className="min-w-fit"
          type="button"
          loading={updatingSettlement}
          disabled={updatingSettlement}
        />
      </div>

      <div className="flex flex-col">
        {Object.entries(values).map(([key, val]) => {
          return (
            <div
              key={key}
              className="flex justify-between items-center border-b py-4 last:border-b-0 first:pt-0"
            >
              <p className="capitalize">{key} Settlemnt</p>

              <CustSwitch
                checked={val}
                disabled={false}
                onChange={(checked) => {
                  setFieldValue(key, checked)
                }}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
